export default __webpack_public_path__ + "images/ZP.7af7c83.png";